import React, { useRef } from 'react';
import { Row, Col, Button } from 'reactstrap';
import moment from 'moment/moment';
import { useReactToPrint } from 'react-to-print';
import { CSVLink } from 'react-csv';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileCsv } from '@fortawesome/free-solid-svg-icons';
//Components
import MainCard from '../../../components/MainCard/MainCard';
import CardRelatorio from '../components/CardRelatorio';

//Context
import { useAuth } from 'context/auth';

export default function RelatorioColetasSintetica({ dadosRelatorio, btnVoltar, filtros }) {
    const { session, setupVariavel } = useAuth();

    //Referencia do relatorio para download do csv
    const exportRef = useRef(null);

    //Botão de exportação csv
    const BtnExportCsv = () => {
        return (
            <Button className='mb-3' color='success' onClick={() => exportRef.current.link.click()}>
                <FontAwesomeIcon icon={faFileCsv} /> Gerar CSV
            </Button>
        )
    }
    //Referencia para a impressão pdf
    const refRelatorio = useRef();

    //Cabeçalhos para a listagem das coletas por meio do cardRelatorio
    const headersColetas = [
        { value: `LOGRADOURO`, objectValue: "logradouro", col: "6" },
        { value: "NOME DO GERADOR", objectValue: "nomeGerador", col: "4" },
        { value: "CPF/CNPJ", objectValue: "cpfcnpj", col: "6" },
        { value: "PESO", objectValue: "pesoColetadoTotal", col: "2" },
    ];

    //Headers para exportar csv
    const headersExport = [
        { key: "logradouro", label: "LOGRADOURO" },
        { key: "nomeGerador", label: "NOME DO GERADOR" },
        { key: "cpfcnpj", label: "CPF/CNPJ" },
        { key: "pesoColetadoTotal", label: "PESO" },
    ]

    //Função assionada assim que o botão de imprimir pdf é clicado
    const handlePrint = useReactToPrint({
        content: () => refRelatorio.current,
        copyStyles: true,
        documentTitle: "Relatório de coletas sintética",
    });

    return (
        <MainCard btnVoltarInTop={btnVoltar} btnImprimir={handlePrint} BtnAction1InTop={BtnExportCsv}>
            <CSVLink separator={";"} data={dadosRelatorio ?? []} headers={headersExport} filename="Relatorio de coletas sintético.csv" target="_blank" ref={exportRef}></CSVLink>
            <div className="mt-4 relatorio w-100" ref={refRelatorio}>
                <div className="print m-2 d-flex align-items-center justify-content-between">
                    <p>Emitido por: {session.nome}</p>
                    <p>Data de emissão: {moment().format("DD/MM/YYYY HH:mm")}</p>
                </div>
                {setupVariavel?.logoTipo &&
                    <div className="d-flex align-items-center justify-content-center">
                        <img src={"data:image/png;base64," + setupVariavel?.logoTipo} style={{ maxWidth: '70%'}} />
                    </div>
                }
                <div className="header">
                    <h4 className='text-black'>Relatório de coletas sintética</h4>
                    <Row>
                        <div className='col-4'>
                            <p><span className="fw-bold">Período:</span> {moment(filtros.dataInicial).format("DD/MM/YYYY")} à {moment(filtros.dataFinal).format("DD/MM/YYYY")}</p>
                        </div>
                    </Row>
                </div>
                <div className="body">
                    <h5 className='rounded-3 bg-secondary text-light p-2'>LOCALIDADES</h5>
                    <CardRelatorio headers={headersColetas} items={dadosRelatorio ?? []} />

                </div>
            </div>
        </MainCard>
    )
}